import { useQuery } from '@apollo/client';
import { UserContext } from '@providers/userContextProvider';
import { useContext } from 'react';
import { useParams } from 'react-router';

import { FETCH_REPORT_NAME } from './customReportBreadcrumb.query';

export function CustomReportBreadcrumb() {
  const { activeOrganization } = useContext(UserContext);
  const { data } = useQuery(FETCH_REPORT_NAME, {
    variables: {
      reportId: useParams().id,
      organizationId: activeOrganization.id,
    },
  });

  return data?.fetchReport?.report.name ?? 'Custom Report';
}
